import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye, faFileCode, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { NFeSummary, NFeStatus } from '../../../types/nfe';
import { downloadXmlNFe } from '../../../services/nfeService';

interface NFeTabelaAcoesProps {
  nfe: NFeSummary;
}

const NFeTabelaAcoes: React.FC<NFeTabelaAcoesProps> = ({ nfe }) => {
  const navigate = useNavigate();
  const isDraft = nfe.status === NFeStatus.Rascunho || nfe.status === NFeStatus.Completa;
  const hasXml = nfe.status === NFeStatus.Autorizada || nfe.status === NFeStatus.Cancelada;

  const handleDownloadXml = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const blob = await downloadXmlNFe(nfe.id);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `nfe_${nfe.chave ?? nfe.id}.xml`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleOpenDanfe = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`/api/nfe/${nfe.nFeId}/danfe`, '_blank');
  };

  return (
    <div className="d-flex gap-1 justify-content-end">
      <button
        className="btn btn-sm btn-subtle-secondary d-inline-flex align-items-center gap-1"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/operacional/nfe/${nfe.id}`);
        }}
        title={isDraft ? 'Editar' : 'Visualizar'}
      >
        <FontAwesomeIcon icon={isDraft ? faPen : faEye} style={{ fontSize: '0.75rem' }} />
        <span style={{ fontSize: '0.78rem' }}>{isDraft ? 'Editar' : 'Ver'}</span>
      </button>

      {hasXml && (
        <button
          className="btn btn-sm btn-subtle-secondary d-inline-flex align-items-center gap-1"
          onClick={handleDownloadXml}
          title="Baixar XML"
        >
          <FontAwesomeIcon icon={faFileCode} style={{ fontSize: '0.75rem' }} />
          <span style={{ fontSize: '0.78rem' }}>XML</span>
        </button>
      )}
      <button
        className="btn btn-sm btn-subtle-secondary d-inline-flex align-items-center gap-1"
        onClick={handleOpenDanfe}
        title={hasXml ? 'Abrir DANFE' : 'Pré-visualizar DANFE'}
      >
        <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '0.75rem' }} />
        <span style={{ fontSize: '0.78rem' }}>DANFE</span>
      </button>
    </div>
  );
};

export default NFeTabelaAcoes;
